module.exports = __webpack_public_path__ + "media/images/pineapple-logo-4a768b74.png";